import type { LocalizedString } from 'typesafe-i18n';

import { ClientDocumentCategoryV5 } from '../../../api/generated/cz.partners.bank.backofficegateway.documents';
import { useI18nContext } from '../../../locale/i18n-react';

export const useClientDocumentCategoryTranslationMap = () => {
	const { LL } = useI18nContext();

	const categoryTranslationMap: Record<
		ClientDocumentCategoryV5,
		LocalizedString
	> = {
		[ClientDocumentCategoryV5.ACCOUNT_CANCELLATION]:
			LL.documents.clientCategories.accountCancellation(),
		[ClientDocumentCategoryV5.COMPLAINTS]:
			LL.documents.clientCategories.complaints(),
		[ClientDocumentCategoryV5.CONFIRMATIONS_STATEMENTS]:
			LL.documents.clientCategories.confirmationStatements(),
		[ClientDocumentCategoryV5.CONTRACTUAL_DOCUMENTATION]:
			LL.documents.clientCategories.contractualDocumentation(),
		[ClientDocumentCategoryV5.DRAWDOWN_DOCUMENTATION]:
			LL.documents.clientCategories.drawdownDocumentation(),
		[ClientDocumentCategoryV5.EXCEPTION_DOCUMENTATION]:
			LL.documents.clientCategories.exceptionDocumentation(),
		[ClientDocumentCategoryV5.INCOME_DOCUMENTATION]:
			LL.documents.clientCategories.incomeDocumentation(),
		[ClientDocumentCategoryV5.INHERITANCE_POWER_OF_ATTORNEY]:
			LL.documents.clientCategories.inheritancePowerOfAttorney(),
		[ClientDocumentCategoryV5.OTHER]: LL.documents.clientCategories.other(),
		[ClientDocumentCategoryV5.OUTGOING_MOBILITY]:
			LL.documents.clientCategories.outgoingMobility(),
		[ClientDocumentCategoryV5.INCOMING_MOBILITY]:
			LL.documents.clientCategories.incomingMobility(),
		[ClientDocumentCategoryV5.POST_DRAWDOWN_DOCUMENTATION]:
			LL.documents.clientCategories.postDrawdownDocumentation(),
		[ClientDocumentCategoryV5.PRE_CONTRACTUAL_DOCUMENTATION]:
			LL.documents.clientCategories.preContractualDocumentation(),
		[ClientDocumentCategoryV5.PROPERTY_DOCUMENTATION]:
			LL.documents.clientCategories.propertyDocumentation(),
	};

	return categoryTranslationMap;
};
